<template lang="pug">
  v-row(
    align="center"
    justify="center"
    class="background"
  )
    v-col(md="5")
      template(v-if="errormsg === 'Your account was not found. Please contact the BU Admin for further assistance'")
        v-alert(
          color="red"
          dismissible
          text
          v-model='snackbar'
          style="text-align: center;"
        ) {{ errormsg}}
      template(v-else)
        v-alert(
          color="red"
          dismissible
          text
          v-model='snackbar'
          style="text-align: center;"
        ) {{ errormsg?errormsg.split(".")[0]:"" }} <br> {{ (errormsg?errormsg.split(".")[1]?" or "+errormsg.split(".")[1]:"" :"")}}

      v-alert(
        color="green"
        dismissible
        text
        v-model='snackbarResend'
      ) {{ messageResend }}
      div(v-if="!isOtp" class="box-shape text-center")
        div(class="text-left pb-5")
          h1 {{ appMode }}
          p(style="color: #5C5C5C;") Enter your credentials to access your account.

        div(class="text-left pb-1" style="color: #5C5C5C;") Email
        v-text-field(
          v-model="email"
          type="email"
          ref="refEmail"
          :rules="[() => !!email || 'E-mail is required', rules.email]"
          single-line
          outlined
          placeholder="Email"
        )

        div(class="text-left pb-1 mt-n2" style="color: #5C5C5C;") Password
        v-text-field(
          v-model="password"
          ref="refPassword"
          @keyup.enter.native="login"
          :append-icon="showPass ? 'visibility' : 'visibility_off'"
          @click:append="showPass = !showPass"
          :rules="[() => !!password || 'Password is required']"
          :type="showPass ? 'text' : 'password'"
          class="mb-:2"
          single-line
          outlined
          placeholder="Password"
        )
        div(class="text-right mt-n3 pb-3")
          router-link(to="/forgetpassword" style="text-decoration: none; color: gray;") Forgot Password!
        v-btn.signin-btn.mt-4(
          type="submit",
          @click="login",
          :loading="loadingData",
          color="blue-primary",
          block,
          style="color: white; padding: 25px"
        ) LOGIN
        
        // OR divider
        div(class="or-divider mt-4 mb-4")
          div(class="or-line")
          span(class="or-text") OR
          div(class="or-line")
        
        GoogleSignIn(@showError="showErrorSSO")

        div(style="display: flex; justify-content: center; padding:1rem")
          p Need an account?&nbsp 
          router-link(to="/listContactAdmin" style="text-decoration: underline; color: #1976D2;") Contact

      div(v-if="isOtp" class="box-shape text-center")
        div(class="text-left pb-5")
          h1 OTP
          p(style="color: #5C5C5C;") Please check your OTP, which has been sent to your WhatsApp or email.
        div.text-left.pb-1(style="color: #5C5C5C;") Enter OTP
        v-text-field(
          v-model="otp"
          ref="refOtp"
          type="text"
          :rules="[() => !!otp || 'OTP is required', v => v.length === 6 || 'OTP must be 6 digits']"
          maxlength="6"
          single-line
          outlined
          placeholder="6-digit OTP"
          @keyup.enter="verifyOtp" 
        )

        div(class="text-right mt-n3 pb-3")
          v-btn(
            @click="resendOtp"
            :disabled="timer > 0"
            style="text-decoration: none; color: gray;"
          ) Resend OTP {{ timer>0?`(${timer} s)`:"" }}
          //- span(v-if="timer > 0") ( seconds remaining)
        
        v-btn.signin-btn.mt-4(
          type="submit",
          @click="verifyOtp",
          :loading="loadingData",
          color="blue-primary",
          block,
          style="color: white; padding: 25px"
        ) Submit
        div(style="display: flex; justify-content: center; padding:1rem")
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import GoogleSignIn from "@/components/GoogleSignIn.vue";

export default {
  name: "LoginCard",
  components: {
    GoogleSignIn
  },
  data: () => ({
    showPass: false,
    email: "",
    password: "",
    snackbar: false,
    errormsg: null,
    snackbarResend: false,
    messageResend:null,
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid email format';
      },
    },
    user_role: null,
    oldEmail: '',
    oldPassword: '',
    appMode: null,
    isOtp: false,
    otp: "",
    timer: 30,
    interval: null,
    otpMail:""
  }),
  mounted() {
    if (process.env.VUE_APP_MODE != 'prod') {
      this.appMode = 'UAT Environment';
    } else {
      this.appMode = 'Welcome back';
    }
  },
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    formIsValid() {
      return this.email && this.password;
    },
  },
  watch: {
    email(newValue, oldValue) {
      this.oldEmail = newValue;
    },
    password(newValue, oldValue) {
      this.oldPassword = newValue;
    },
    timer(newTimer) {
      if (newTimer <= 0 && this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
  },
  methods: {
    login() {
      const { email, password } = this;
      if (!email) {
        this.showError("E-mail is required");
        this.password = this.oldPassword;
      }
      if (!password && email) {
        this.showError("Password is required");
        this.email = this.oldEmail;
      }

      this.otpMail = email.toString()
      if (password && email) {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (pattern.test(email)) {
          this.$store
            .dispatch("otpLogin", { email, password })
            .then((flag) => {
              if (flag.status) {
                console.log("===")
                console.log(flag)
                this.isOtp = true;
                this.startTimer();
                this.timer=10
                if(flag.error.error){
                  
                  this.showErrorOtp(flag.error.message);
                }
              }
            })
            .catch((message) => {
              if (message.response.data.statusCode === 400) {
                this.showError("Wrong email or password! Please try again.press Shift+Ctrl+R if the password entered is correct but you still get an error");
                this.email = this.oldEmail;
                this.password = this.oldPassword;
              } else if (message.response.data.statusCode === 403) {
                this.showError(message.response.data.message);
                this.email = this.oldEmail;
                this.password = this.oldPassword;
              } else {
                this.showError(message.response.data.message);
                this.email = this.oldEmail;
                this.password = this.oldPassword;
              }
            });
        } else {
          this.showError("Invalid email format");
          this.email = this.oldEmail;
          this.password = this.oldPassword;
        }
      }
    },
    verifyOtp() {
      const { email, otp } = this;
      let emailUsed = email?email.toString():this.otpMail
      console.log({ email, otp })
      console.log("OTP MAIL : ")
      console.log(this.otpMail)
      // if(!email){
      //   emailUsed = this.otpMail
      //   // email = this.otpMail
      // }
      console.log("current mail : ")
      console.log(emailUsed)
      if (emailUsed && otp) {
        this.$store
          .dispatch("otpVerify", { email:emailUsed, otp })
          .then((flag) => {
            if (flag) {
              this.isOtp = false;
            }
            if (this.showDrawer) this.$store.commit("toggleDrawer");
            this.getDataUser();
          })
          .catch((message) => {
            if (message.response.data.statusCode !== 200) {
              this.showErrorOtp("OTP is Not Valid / Expired");
            }
          });
      }
    },
    resendOtp() {
      this.timer = 30; // reset timer to 60 seconds
      this.startTimer();
      // Add logic to resend OTP
      const { email,password } = this;
      this.otpMail=email.toString()
      this.$store
        .dispatch("otpLogin", { email,password }) // Assuming you are using the same action to resend OTP
        .then(() => {
          this.showResent("OTP has been resent.");
        })
        .catch((message) => {
          this.showError(message.response.data.message);
        });
    },
    startTimer() {
      this.interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        }
      }, 1000);
    },
    getDataUser() {
      let token = localStorage.getItem('token');
      axios.get(process.env.VUE_APP_API + `/users/info`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          let count = parseInt(localStorage.getItem(this.email));
          let user = JSON.parse(localStorage.getItem('user'));
          if (isNaN(count)) {
            localStorage.setItem(this.email, 1);
          } else {
            if (count < 2) {
              localStorage.setItem(user.email, count + 1);
            } else {
              localStorage.setItem("animationPointer", true);
            }
          }

          const redirect = this.$route.query.redirect;
          if (redirect) {
            this.$router.push(redirect)
          } else {
            if (res.data.data.role === 'super_user') {
              this.$router.push("my-request");
            } else {
              this.$router.push("/");
            }
          }
        })
        .catch(err => {
          if (err.response.status == 401) {
            return this.$router.push("/logout");
          }
        })
        .finally(() => (this.loading = false));
    },
    showError(message) {
      this.email = null;
      this.password = null;
      this.errormsg = message;
      this.snackbar = true;
      this.snackbarResend=false
    },
    showErrorSSO(message) {
      this.errormsg = message;
      this.snackbar = true;
      this.snackbarResend=false
    },
    showErrorOtp(message) {
      this.errormsg = message;
      this.snackbar = true;
      this.snackbarResend=false
    },
    showResent(message) {
      this.messageResend = message;
      this.snackbarResend = true;
      this.snackbar=false
    },
  },
};
</script>

<style>
.box-shape {
  background: #FFFFFF;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.11);
  padding: 3rem;
  margin-top: 0.5rem;
}

.background {
  background-image: url("../assets/bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
}

.logo {
  width: 120px;
  height: auto;
}

.or-divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;
}

.or-line {
  flex: 1;
  height: 1px;
  background-color: #e0e0e0;
}

.or-text {
  padding: 0 15px;
  color: #9e9e9e;
  font-size: 14px;
  font-weight: 500;
}
</style>
